import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Bulk stage change across mixed pipeline items. A lead stage applies only to selected
// leads; a bid stage only to selected bids — the backend skips anything that doesn't fit.
const GROUPS = [
  ["Leads", [["new", "Intake"], ["review", "Reviewing"]]],
  ["Estimates & bids", [["estimating", "Estimating"], ["proposal", "Proposal"], ["sent", "Submitted"]]],
];

export function PipelineStageDialog({ open, onOpenChange, count, onConfirm }) {
  const [stage, setStage] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => { if (!stage) return; setBusy(true); try { await onConfirm(stage); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setStage(""); onOpenChange(o); }}>
      <DialogContent data-testid="pipeline-stage-dialog">
        <DialogHeader>
          <DialogTitle>Change stage · {count} item{count === 1 ? "" : "s"}</DialogTitle>
          <DialogDescription>Pick a stage. A lead stage only moves selected leads; an estimate stage only moves selected bids — anything that doesn't fit is skipped.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {GROUPS.map(([label, opts]) => (
            <div key={label}>
              <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400 mb-1.5">{label}</div>
              <div className="flex flex-wrap gap-2">
                {opts.map(([k, lab]) => (
                  <button key={k} data-testid={`pstage-opt-${k}`} onClick={() => setStage(k)}
                    className={`text-sm px-3 py-2 rounded-lg border transition-colors ${stage === k ? "bg-[#003E87] text-white border-[#003E87]" : "text-slate-600 border-slate-200 hover:bg-slate-50"}`}>{lab}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="pstage-cancel">Cancel</Button>
          <Button disabled={!stage || busy} onClick={submit} data-testid="pstage-confirm" className="bg-[#003E87] hover:bg-[#00305F] text-white">Apply</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
